/* Statistiche (port di stats.js) — statistiche account + lookup per user_id. */
import { useEffect, useState } from "react";
import { ptapp } from "@/lib/ptapp";
import { Card, Row, AccountSelect, Pill } from "./_ui";

const humanize = (k: string) => k.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
const isPlain = (v: any) => v && typeof v === "object" && !Array.isArray(v);
function flatten(obj: any, prefix = ""): [string, string][] {
  const out: [string, string][] = [];
  Object.keys(obj || {}).forEach((k) => {
    const v = obj[k]; const label = prefix ? prefix + " / " + humanize(k) : humanize(k);
    if (isPlain(v)) out.push(...flatten(v, label));
    else if (Array.isArray(v)) out.push([label, v.length && isPlain(v[0]) ? v.length + " elementi" : (v.length ? v.join(", ") : "—")]);
    else if (v == null || v === "") out.push([label, "—"]);
    else if (typeof v === "number" && !Number.isInteger(v)) out.push([label, String(Math.round(v * 100) / 100)]);
    else out.push([label, String(v)]);
  });
  return out;
}

function StatsView({ data }: { data: any }) {
  const root = isPlain(data) && isPlain(data.stats) ? data.stats : data;
  const pairs = flatten(root);
  if (!pairs.length) return <div className="text-sm text-slate-500">Nessuna statistica disponibile.</div>;
  return <div className="grid grid-cols-1 gap-x-8 sm:grid-cols-2">{pairs.map(([k, v]) => <Row key={k} k={k} v={<Pill>{v}</Pill>} />)}</div>;
}

export default function Stats() {
  const [acct, setAcct] = useState("moving");
  const [mine, setMine] = useState<any>(null);
  const [uid, setUid] = useState("");
  const [other, setOther] = useState<{ stats: any; tenants: any[] } | null>(null);
  const [tnames, setTnames] = useState<Record<string, string>>({});

  useEffect(() => { setMine(null); ptapp.call<any>(acct, "app", "v1/social/users/me/stats").then(setMine).catch(() => setMine({})); }, [acct]);

  const lookup = async () => {
    const id = uid.trim(); if (!id) return; setOther(null);
    const [s, t] = await Promise.all([
      ptapp.call<any>(acct, "app", "v1/social/users/" + id + "/stats").catch(() => null),
      ptapp.call<any[]>(acct, "apiapp", "v1/matches_summary/top_tenants_by_player", { params: { player_user_id: id } }).catch(() => []),
    ]);
    const tops = (Array.isArray(t) ? t : []).sort((a, b) => (b.count || 0) - (a.count || 0)).slice(0, 8);
    await Promise.all(tops.map(async (x) => { if (tnames[x.tenant_id]) return; try { const tt = await ptapp.call<any>(acct, "apiapp", "v1/tenants/" + x.tenant_id); setTnames((p) => ({ ...p, [x.tenant_id]: (tt.tenant_name || tt.name || x.tenant_id).trim() })); } catch { /* */ } }));
    setOther({ stats: s, tenants: tops });
  };

  return (
    <div className="mx-auto max-w-3xl space-y-4 p-4">
      <div className="flex items-center gap-3">
        <h2 className="text-lg font-bold text-slate-900">Statistiche</h2>
        <AccountSelect value={acct} onChange={setAcct} />
      </div>

      <Card title="Le mie statistiche">{mine == null ? <div className="text-sm text-slate-500">carico…</div> : <StatsView data={mine} />}</Card>

      <Card title="Statistiche di un altro giocatore">
        <div className="flex gap-2">
          <input value={uid} onChange={(e) => setUid(e.target.value)} onKeyDown={(e) => e.key === "Enter" && lookup()} placeholder="User ID del giocatore" className="flex-1 rounded-md border border-slate-300 px-3 py-2 text-sm" />
          <button onClick={lookup} className="rounded-md bg-moving-500 px-4 py-2 text-sm font-semibold text-white hover:opacity-90">Cerca</button>
        </div>
        {other && (
          <div className="mt-3 space-y-3">
            <div><div className="mb-1 text-sm font-semibold text-slate-700">Statistiche</div>{other.stats ? <StatsView data={other.stats} /> : <div className="text-sm text-slate-400">non disponibili</div>}</div>
            <div><div className="mb-1 text-sm font-semibold text-slate-700">Dove gioca</div>
              {other.tenants.length ? other.tenants.map((t) => <Row key={t.tenant_id} k={tnames[t.tenant_id] || t.tenant_id} v={<Pill>{t.count} partite</Pill>} />) : <div className="text-sm text-slate-400">—</div>}
            </div>
          </div>
        )}
      </Card>
    </div>
  );
}
